import angular from 'angular';
import { GeracaoDeMarcacoesPadraoService } from './geracao-de-marcacoes-padrao.service';

export const GeracaoDeMarcacoesPadraoListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const accessResolve = [
            '$rootScope',
            '$state',
            '$q',
            function (
                $rootScope: angular.IRootScopeService & {
                    liberadoTela: (arg: string) => boolean,
                },
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if ($rootScope.liberadoTela('LIBERAR_GERACAO_MARCACOES_LOTE')) {
                    return true;
                }

                $state.go('dp');
                return $q.reject('Acesso negado ao módulo de geração de marcações padrão.');
            }
        ];

        const showResolve = {
            'access': accessResolve,
            'entity': [
                'access',
                'GeracaoDeMarcacoesPadraoService',
                '$stateParams',
                '$state',
                '$q',
                function (
                    _access: boolean,
                    entityService: GeracaoDeMarcacoesPadraoService,
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['importacaomarcacao']) {
                        return $q<void>(() => $state.go('geracaodemarcacoespadrao'));
                    }

                    return entityService.get($stateParams['importacaomarcacao'])
                        .then((data) => {
                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => $state.go('not_found', $stateParams));
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('geracaodemarcacoespadrao', {
                url: '/ponto/geracao-de-marcacoes-padrao',
                template: require('html-loader!./index/geracao-de-marcacoes-padrao.index.html'),
                resolve: {
                    'access': accessResolve
                },
                controller: 'GeracaoDeMarcacoesPadraoIndexController',
                controllerAs: 'grcdmrccspdr_cntrllr'
            })
            .state('geracaodemarcacoespadrao_new', {
                url: '/ponto/geracao-de-marcacoes-padrao/new',
                template: require('html-loader!./new/geracao-de-marcacoes-padrao.new.html'),
                resolve: {
                    'access': accessResolve
                },
                controller: 'GeracaoDeMarcacoesPadraoNewController',
                controllerAs: 'grcdmrccspdr_cntrllr_nw_cntrllr'
            })
            .state('geracaodemarcacoespadrao_show', {
                url: '/ponto/geracao-de-marcacoes-padrao/show/{importacaomarcacao}',
                template: require('html-loader!./show/geracao-de-marcacoes-padrao.show.html'),
                resolve: showResolve,
                controller: 'GeracaoDeMarcacoesPadraoShowController',
                controllerAs: 'grcdmrccspdr_cntrllr_shw_cntrllr'
            });
    }
];
